import { useState } from 'react';

interface ThemeStore {
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
}

const getSystemTheme = (): 'light' | 'dark' =>
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

let globalTheme: 'light' | 'dark' = getSystemTheme();
const listeners = new Set<(theme: 'light' | 'dark') => void>();

const useThemeStore = (): ThemeStore => {
  const [theme, setThemeState] = useState(globalTheme);

  const setTheme = (newTheme: 'light' | 'dark') => {
    globalTheme = newTheme;
    for (const listener of listeners) {
      listener(newTheme);
    }
  };

  useState(() => {
    listeners.add(setThemeState);
    return () => {
      listeners.delete(setThemeState);
    };
  });

  return { theme, setTheme };
};

export default useThemeStore;
